const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.monkCapital.moneyMonk";

const LINKRUNNER_URLS = {
  header: "https://app.moneymonkapp.in/?c=website-header-download",
  footer: "https://app.moneymonkapp.in/?c=website-footer-download",
};

export function getPlayStoreUrl(campaign) {
  const isAndroid = /Android/i.test(navigator.userAgent);
  return isAndroid ? LINKRUNNER_URLS[campaign] : PLAY_STORE_URL;
}
